import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { HouseIcon } from "../core/icons/Icons";
import { Stepper } from "../core/Stepper";
import { useStyles } from "../../useStyles";

export const ModificationHousingUnitsForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<ChangeNames.MODIFICATION_HOUSING_UNITS>();
    return (
        <div style={{ marginTop: 32 }}>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<HouseIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Anzahl der Wohneinheiten
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 28 }}>
                            Geben Sie hier die Anzahl der Wohneinheiten ein.
                        </p>
                        <Stepper
                            allowNegative={false}
                            value={values.modificationHousingUnits.value.units || 0}
                            onValueChange={v =>
                                setValues(values => {
                                    values.modificationHousingUnits.value.units =
                                        v.floatValue || values.modificationHousingUnits.value.units;
                                })
                            }
                        />
                    </Fragment>
                }
            />
        </div>
    );
};
